import { useRef } from 'react';
import Footer from '@/components/Footer';
import Hero from '@/components/Contacto';
import getMetadata from '@/utils/getMetadata';
import { NextSeo } from 'next-seo';
import localeManager from '@/utils/localeManager';
import useLangMenuBar from "@/hooks/useLangMenuBar";


const Contacto = ({ locale, footer, contact, country_short_name, form, menu }) => {
  const root = useRef();
  useLangMenuBar(menu)

  return (
    <main ref={root} className="relative site-max mx-auto contacto">
      <NextSeo
        {...getMetadata({
          locale,
          title: 'Contacto',
          description:
            '¡Estamos para ayudarte! Dejanos tu consulta y nos pondremos en contacto en la brevedad.',
          pathname: '/contacto'
        })}
      />
      <Hero contact={contact} country_short_name={country_short_name} form={form} />
        <Footer footer={footer} locale={locale} />
    </main>
  );
};

export default Contacto;

export async function getServerSideProps({ req, locale: nextLocale, defaultLocale }) {
  const { locale, dict } = await localeManager.getLocaleResources(req, {}, nextLocale || defaultLocale);

  return {
    props: {
      locale,
      footer: dict.home.footer,
      contact: dict.contact,
      country_short_name: dict.country_short_name,
      form: dict.contact.form,
      menu: dict.menu
    }
  };
}
